<template>
    <div>
        <!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'线索管理'}]" />-->

            <!-- 实时招标搜素条件 -->
            <div v-if = "fromSourceType=='second'" class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">

                            <el-form-item label="战区" prop="areaName">
                                <brselect :dictNameAsValues=true category="show_area" :v="q.bigArea" v-model="q.bigArea"
                                          :clearable="true"
                                          style="width:100%"/>
                            </el-form-item>
                            <el-form-item label="省区" prop="province">
                                <el-select v-model="q.province" filterable clearable style="width: 80%;">
                                    <el-option
                                        v-for="item in shenglist"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>

                            </el-form-item>
                            <el-form-item label="销售人员">
                                <el-input v-model="q.salesManNameAndCode" placeholder="请输入名称/编码"
                                          :clearable="true"></el-input>
                            </el-form-item>

                            <el-form-item label="项目名称">
                                <el-input v-model="q.projectName" placeholder="请输入项目名称"
                                          :clearable="true"></el-input>
                            </el-form-item>

                            <el-form-item label="线索状态" prop="trackStatus">
                                <brselectlazy category="track_status_zb" :v="q.trackStatus" v-model="q.trackStatus"
                                              :clearable="true"
                                              style="width:100%"/>
                            </el-form-item>


                        </div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">

                                    <el-form-item label="处理状态" prop="state">
                                        <el-select v-model="q.state" :clearable="true">
                                            <el-option label="待办" value="0">待办</el-option>
                                            <el-option label="已办" value="1">已办</el-option>
                                        </el-select>
                                    </el-form-item>


                                    <el-form-item label="渠道名称" prop="channelName">
                                        <brselect category="clue_channel_zb" :v="q.channelCode" v-model="q.channelCode"
                                                  :clearable="true"
                                                  style="width:100%"/>
                                    </el-form-item>
                                    <el-form-item label="线索来源" prop="clueFrom">
                                        <el-select v-model="q.clueFrom" placeholder="请选择">
                                            <el-option label="国家端口" value="022"></el-option>
                                            <el-option label="招标网" value="023"></el-option>
                                        </el-select>

                                    </el-form-item>
                                    <el-form-item label="创建日期" class="timeselect" style="width: 50%;">
                                        <el-date-picker
                                            placeholder="请选择"
                                            v-model="q.startDate"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                            placeholder="请选择"
                                            v-model="q.endDate"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>

                            </div>
                        </el-collapse-transition>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
                        </div>
                        <div class="l-retrieval">
                            <!--                            <el-button v-if="!dailishangFlag" class="h-btn h-formBtn h-bggreen" @click="designate">
                                                            指派
                                                        </el-button>-->
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                            <!--                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                                                            新增
                                                        </el-button>-->
                        </div>
                    </div>
                </div>
            </div>
            <!-- 其他搜素条件 -->
            <div v-if = "fromSourceType!='second'" class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">

                            <el-form-item label="战区" prop="areaName">
                                <brselect :dictNameAsValues=true category="show_area" :v="q.bigArea" v-model="q.bigArea"
                                          :clearable="true"
                                          style="width:100%"/>
                            </el-form-item>
                            <el-form-item label="省区" prop="province">
                                <el-select v-model="q.province" filterable clearable style="width: 80%;">
                                    <el-option
                                        v-for="item in shenglist"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>

                            </el-form-item>
                            <el-form-item label="销售人员">
                                <el-input v-model="q.salesManNameAndCode" placeholder="请输入名称/编码"
                                          :clearable="true"></el-input>
                            </el-form-item>

                            <el-form-item label="项目名称">
                                <el-input v-model="q.projectName" placeholder="请输入项目名称"
                                          :clearable="true"></el-input>
                            </el-form-item>

                            <el-form-item label="线索状态" prop="trackStatus">
                                <brselectlazy category="track_status_zb" :v="q.trackStatus" v-model="q.trackStatus"
                                              :clearable="true"
                                              style="width:100%"/>
                            </el-form-item>

                        </div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="处理状态" prop="state">
                                        <el-select v-model="q.state" :clearable="true">
                                            <el-option label="待办" value="0">待办</el-option>
                                            <el-option label="已办" value="1">已办</el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="渠道名称" prop="channelName">
                                        <brselect category="clue_channel_zb" :v="q.channelCode" v-model="q.channelCode"
                                                  :clearable="true"
                                                  style="width:100%"/>
                                    </el-form-item>
                                    <el-form-item label="创建日期" class="timeselect" style="width: 50%;">
                                        <el-date-picker
                                            placeholder="请选择"
                                            v-model="q.startDate"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                            placeholder="请选择"
                                            v-model="q.endDate"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                    </el-form-item>

                                </div>


                            </div>
                        </el-collapse-transition>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
                        </div>
                        <div class="l-retrieval">
<!--                            <el-button v-if="!dailishangFlag" class="h-btn h-formBtn h-bggreen" @click="designate">
                                指派
                            </el-button>-->
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
<!--                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                                新增
                            </el-button>-->
                        </div>
                    </div>
                </div>
            </div>


            <!-- 实时招标结果展示 -->
            <div  v-if = "fromSourceType=='second'" class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :border="true"
                    max-height="560"
                    style="width: 100%"
                >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50px">
                    </el-table-column>
                    <el-table-column prop="bigArea" label="战区" width="100px"></el-table-column>
                    <el-table-column prop="province" label="省" width="100px"></el-table-column>
                    <el-table-column prop="city" label="市" width="80px"></el-table-column>

                    <el-table-column prop="projectName" :show-overflow-tooltip="true"  label="项目名称" width="280px"></el-table-column>
                    <el-table-column prop="industry" label="对应产业链群" width="130px"></el-table-column>

                    <el-table-column prop="salesManName" :show-overflow-tooltip="true" label="销售人员" width="180px"></el-table-column>
                    <el-table-column prop="channelName" label="渠道名称" width="100px"></el-table-column>
                    <el-table-column prop="clueFromName" label="线索来源" width="100px"></el-table-column>
                    <el-table-column prop="userUnitName" label="用户单位" width="180px"></el-table-column>

                    <el-table-column prop="userRequire" label="线索原文"  width="280px">
                        <template slot-scope="scope">
                            <el-link v-if="isUrl(scope.row.userRequire)" :href="scope.row.userRequire" target="_blank"
                                     type="primary">
                                {{ scope.row.userRequire }}
                            </el-link>
                            <span v-if="!isUrl(scope.row.userRequire)">{{ scope.row.userRequire }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="funnelCode" label="漏斗编号" width="130px" ></el-table-column>
                    <el-table-column prop="funnelMoney" label="漏斗金额（元）" width="120px" ></el-table-column>
                    <el-table-column prop="estimatedAmount" label="预估金额" width="120px" ></el-table-column>


                    <el-table-column prop="state" label="线索状态" width="100px">
                        <template slot-scope="scope">
                            <dictname category="track_status_zb" :v="scope.row.trackStatus"></dictname>
                        </template>
                    </el-table-column>
                    <el-table-column prop="state" label="处理状态" width="80px">
                        <template scope="scope">
                            <span v-if="scope.row.state == 1">已办</span>
                            <span v-if="scope.row.state == 0">待办</span>
                        </template>
                    </el-table-column>


                    <el-table-column prop="taskType" label="任务类型" width="100px">
                        <template slot-scope="scope">
                            <dictname category="zb_task_type" :v="scope.row.taskType"></dictname>
                        </template>
                    </el-table-column>

                    <el-table-column prop="matchedWords" label="关键字" width="180px"></el-table-column>

                    <el-table-column prop="cdate" label="创建时间" width="150px"></el-table-column>
                    <el-table-column prop="memo" label="备注" width="100px"></el-table-column>
                    <el-table-column
                        label="操作"
                        fixed="right"
                        width="300"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.id" style="text-align: left;">

                                <el-button
                                    v-if=" _user.usercode ==  scope.row.salesManCode && scope.row.state == 0 && (scope.row.taskType == 4 || scope.row.taskType == 5 ) "
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="designate(scope.row)"
                                >确认指派
                                </el-button>

                                <el-button
                                    v-if="(scope.row.trackStatus == '' || scope.row.trackStatus == null) && _user.usercode ==  scope.row.salesManCode && (scope.row.taskType != 4 && scope.row.taskType != 5  && scope.row.taskType!=9)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="undertakeOpen(scope.row)"
                                >承接
                                </el-button>

                                <!-- 销售人员为当前登录人，并且没有承接的 且不等于员工待指派  -->
                                <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="selectcluedetails(scope.row)">
                                    跟踪日志
                                </el-button>

                                <el-button
                                    v-if="scope.row.trackStatus == '1' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag )"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="toProject(scope.row)">
                                    转项目
                                </el-button>
                                <el-button
                                    v-if="scope.row.trackStatus == '4' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="updateDetailxs(scope.row.loudId)">
                                    漏斗
                                </el-button>

                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 新渠道结果展示 -->
            <div  v-if = "fromSourceType=='fifth'" class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :border="true"
                    max-height="560"
                    style="width: 100%"
                >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50px">
                    </el-table-column>
                    <el-table-column prop="bigArea" label="战区" width="100px"></el-table-column>
                    <el-table-column prop="province" label="省" width="100px"></el-table-column>
                    <el-table-column prop="city" label="市" width="80px"></el-table-column>

                    <el-table-column prop="projectName" :show-overflow-tooltip="true"  label="线索名称" width="280px"></el-table-column>
                    <el-table-column prop="industry" label="对应产业链群" width="130px"></el-table-column>

                    <el-table-column prop="salesManName" :show-overflow-tooltip="true" label="销售人员" width="180px"></el-table-column>
                    <el-table-column prop="channelName" label="渠道名称" width="100px"></el-table-column>
                    <el-table-column prop="clueFromName" label="线索来源" width="100px"></el-table-column>
                    <el-table-column prop="userUnitName" label="用户单位" width="180px"></el-table-column>

                    <el-table-column prop="userRequire" label="线索原文"  width="280px">
                        <template slot-scope="scope">
                            <el-link v-if="isUrl(scope.row.userRequire)" :href="scope.row.userRequire" target="_blank"
                                     type="primary">
                                {{ scope.row.userRequire }}
                            </el-link>
                            <span v-if="!isUrl(scope.row.userRequire)">{{ scope.row.userRequire }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="funnelCode" label="漏斗编号" width="130px" ></el-table-column>
                    <el-table-column prop="funnelMoney" label="漏斗金额（元）" width="120px" ></el-table-column>
                    <el-table-column prop="estimatedAmount" label="预估金额" width="120px" ></el-table-column>


                    <el-table-column prop="state" label="线索状态" width="100px">
                        <template slot-scope="scope">
                            <dictname category="track_status_zb" :v="scope.row.trackStatus"></dictname>
                        </template>
                    </el-table-column>
                    <el-table-column prop="state" label="处理状态" width="80px">
                        <template scope="scope">
                            <span v-if="scope.row.state == 1">已办</span>
                            <span v-if="scope.row.state == 0">待办</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="ncProductCategory" label="产品类别" width="120px"></el-table-column>
                    <el-table-column prop="ncProductName" label="产品/解决方案名称" width="180px"></el-table-column>
                    <el-table-column prop="ncCompany" label="归属公司" width="180px"></el-table-column>
                    <el-table-column prop="ncCreditNo" label="统一信用代码" width="180px"></el-table-column>
                    <el-table-column prop="ncFullName" label="联系人" width="180px"></el-table-column>
                    <el-table-column prop="ncMobilePhone" label="联系电话" width="180px"></el-table-column>
                    <el-table-column prop="ncAddress" label="地址" width="180px"></el-table-column>
                    <el-table-column prop="ncPromoCode" label="优惠码" width="180px"></el-table-column>
                    <el-table-column prop="ncDemandContent" label="需求详情" width="180px"></el-table-column>

                    <el-table-column prop="taskType" label="任务类型" width="100px">
                        <template slot-scope="scope">
                            <dictname category="zb_task_type" :v="scope.row.taskType"></dictname>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cdate" label="创建时间" width="150px"></el-table-column>
                    <el-table-column prop="memo" label="备注" width="100px"></el-table-column>
                    <el-table-column
                        label="操作"
                        fixed="right"
                        width="300"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.id" style="text-align: left;">

                                <el-button
                                    v-if=" _user.usercode ==  scope.row.salesManCode && scope.row.state == 0 && (scope.row.taskType == 4 || scope.row.taskType == 5 ) "
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="designate(scope.row)"
                                >确认指派
                                </el-button>

                                <el-button
                                    v-if="(scope.row.trackStatus == '' || scope.row.trackStatus == null) && _user.usercode ==  scope.row.salesManCode && (scope.row.taskType != 4 && scope.row.taskType != 5  && scope.row.taskType!=9)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="undertakeOpen(scope.row)"
                                >承接
                                </el-button>

                                <!-- 销售人员为当前登录人，并且没有承接的 且不等于员工待指派  -->
                                <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="selectcluedetails(scope.row)">
                                    跟踪日志
                                </el-button>

                                <el-button
                                    v-if="scope.row.trackStatus == '1' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="toProject(scope.row)">
                                    转项目
                                </el-button>
                                <el-button
                                    v-if="scope.row.trackStatus == '4' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="updateDetailxs(scope.row.loudId)">
                                    漏斗
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 设计院结果展示 -->
            <div  v-if = "fromSourceType=='third'" class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :border="true"
                    max-height="560"
                    style="width: 100%"
                >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50px">
                    </el-table-column>
                    <el-table-column prop="bigArea" label="战区" width="100px"></el-table-column>
                    <el-table-column prop="province" label="省" width="100px"></el-table-column>
                    <el-table-column prop="city" label="市" width="80px"></el-table-column>

                    <el-table-column prop="projectName" :show-overflow-tooltip="true"  label="项目名称" width="280px"></el-table-column>
                    <el-table-column prop="industry" label="对应产业链群" width="130px"></el-table-column>

                    <el-table-column prop="salesManName" :show-overflow-tooltip="true" label="销售人员" width="180px"></el-table-column>
                    <el-table-column prop="channelName" label="渠道名称" width="100px"></el-table-column>
                    <el-table-column prop="clueFromName" label="线索来源" width="100px"></el-table-column>
                    <el-table-column prop="userUnitName" label="用户单位" width="180px"></el-table-column>

                    <el-table-column prop="userRequire" label="线索原文"  width="280px">
                        <template slot-scope="scope">
                            <el-link v-if="isUrl(scope.row.userRequire)" :href="scope.row.userRequire" target="_blank"
                                     type="primary">
                                {{ scope.row.userRequire }}
                            </el-link>
                            <span v-if="!isUrl(scope.row.userRequire)">{{ scope.row.userRequire }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="funnelCode" label="漏斗编号" width="130px" ></el-table-column>
                    <el-table-column prop="funnelMoney" label="漏斗金额（元）" width="120px" ></el-table-column>
                    <el-table-column prop="estimatedAmount" label="预估金额" width="120px" ></el-table-column>

                    <el-table-column prop="state" label="线索状态" width="100px">
                        <template slot-scope="scope">
                            <dictname category="track_status_zb" :v="scope.row.trackStatus"></dictname>
                        </template>
                    </el-table-column>
                    <el-table-column prop="state" label="处理状态" width="80px">
                        <template scope="scope">
                            <span v-if="scope.row.state == 1">已办</span>
                            <span v-if="scope.row.state == 0">待办</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="projectAmount" label="项目金额" width="120px"></el-table-column>
                    <el-table-column prop="prjProgress" label="拟建项目进展" width="120px"></el-table-column>
                    <el-table-column prop="prjContent" label="拟建项目建设内容" width="180px"></el-table-column>
                    <el-table-column prop="prjSurvey" label="拟建项目概况" width="180px"></el-table-column>

                    <el-table-column prop="taskType" label="任务类型" width="100px">
                        <template slot-scope="scope">
                            <dictname category="zb_task_type" :v="scope.row.taskType"></dictname>
                        </template>
                    </el-table-column>

                    <el-table-column prop="matchedWords" label="关键字" width="180px"></el-table-column>

                    <el-table-column prop="cdate" label="创建时间" width="150px"></el-table-column>
                    <el-table-column prop="memo" label="备注" width="100px"></el-table-column>
                    <el-table-column
                        label="操作"
                        fixed="right"
                        width="300"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.id" style="text-align: left;">

                                <el-button
                                    v-if=" _user.usercode ==  scope.row.salesManCode && scope.row.state == 0 && (scope.row.taskType == 4 || scope.row.taskType == 5 ) "
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="designate(scope.row)"
                                >确认指派
                                </el-button>

                                <el-button
                                    v-if="(scope.row.trackStatus == '' || scope.row.trackStatus == null) && _user.usercode ==  scope.row.salesManCode && (scope.row.taskType != 4 && scope.row.taskType != 5  && scope.row.taskType!=9)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="undertakeOpen(scope.row)"
                                >承接
                                </el-button>

                                <!-- 销售人员为当前登录人，并且没有承接的 且不等于员工待指派  -->
                                <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="selectcluedetails(scope.row)">
                                    跟踪日志
                                </el-button>

                                <el-button
                                    v-if="scope.row.trackStatus == '1' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="toProject(scope.row)">
                                    转项目
                                </el-button>
                                <el-button
                                    v-if="scope.row.trackStatus == '4' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="updateDetailxs(scope.row.loudId)">
                                    漏斗
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 新营销结果展示 -->
            <div  v-if = "fromSourceType=='fourth'" class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :border="true"
                    max-height="560"
                    style="width: 100%"
                >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50px">
                    </el-table-column>
                    <el-table-column prop="bigArea" label="战区" width="100px"></el-table-column>
                    <el-table-column prop="province" label="省" width="100px"></el-table-column>
                    <el-table-column prop="city" label="市" width="80px"></el-table-column>

                    <el-table-column prop="projectName" :show-overflow-tooltip="true"  label="线索名称" width="280px"></el-table-column>
                    <el-table-column prop="industry" label="对应产业链群" width="130px"></el-table-column>

                    <el-table-column prop="salesManName" :show-overflow-tooltip="true" label="销售人员" width="180px"></el-table-column>
                    <el-table-column prop="channelName" label="渠道名称" width="100px"></el-table-column>
                    <el-table-column prop="clueFromName" label="线索来源" width="100px"></el-table-column>
                    <el-table-column prop="userUnitName" label="用户单位" width="180px"></el-table-column>

                    <el-table-column prop="userRequire" label="线索原文"  width="280px">
                        <template slot-scope="scope">
                            <el-link v-if="isUrl(scope.row.userRequire)" :href="scope.row.userRequire" target="_blank"
                                     type="primary">
                                {{ scope.row.userRequire }}
                            </el-link>
                            <span v-if="!isUrl(scope.row.userRequire)">{{ scope.row.userRequire }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="funnelCode" label="漏斗编号" width="130px" ></el-table-column>
                    <el-table-column prop="funnelMoney" label="漏斗金额（元）" width="120px" ></el-table-column>
                    <el-table-column prop="estimatedAmount" label="预估金额" width="120px" ></el-table-column>

                    <el-table-column prop="state" label="线索状态" width="100px">
                        <template slot-scope="scope">
                            <dictname category="track_status_zb" :v="scope.row.trackStatus"></dictname>
                        </template>
                    </el-table-column>
                    <el-table-column prop="state" label="处理状态" width="80px">
                        <template scope="scope">
                            <span v-if="scope.row.state == 1">已办</span>
                            <span v-if="scope.row.state == 0">待办</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="yxFullname" label="姓名" width="120px"></el-table-column>
                    <el-table-column prop="yxMobilephone" label="手机号" width="120px"></el-table-column>
                    <el-table-column prop="yxEmail" label="邮箱" width="120px"></el-table-column>
                    <el-table-column prop="yxCompany" label="公司" width="120px"></el-table-column>
                    <el-table-column prop="yxAddress" label="地区" width="120px"></el-table-column>
                    <el-table-column prop="yxGender" label="性别" width="120px"></el-table-column>
                    <el-table-column prop="yxEnterprisescale" label="公司规模" width="120px"></el-table-column>
                    <el-table-column prop="yxScrmmember38939" label="职位" width="120px"></el-table-column>
                    <el-table-column prop="yxField6640" label="感兴趣的产品" width="120px"></el-table-column>
                    <el-table-column prop="yxField5581" label="感兴趣的场景" width="120px"></el-table-column>
                    <el-table-column prop="yxScrmmember39356" label="近期采购计划" width="120px"></el-table-column>
                    <el-table-column prop="yxScrmmember39357" label="是否希望海尔生物医疗取得联系" width="120px"></el-table-column>
                    <el-table-column prop="yxScrmmember39358" label="是否希望盈康一生取得联系" width="120px"></el-table-column>
                    <el-table-column prop="yxOriginalSubSource" label="线索概况" width="220px"></el-table-column>

                    <el-table-column prop="taskType" label="任务类型" width="100px">
                        <template slot-scope="scope">
                            <dictname category="zb_task_type" :v="scope.row.taskType"></dictname>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cdate" label="创建时间" width="150px"></el-table-column>
                    <el-table-column prop="memo" label="备注" width="100px"></el-table-column>
                    <el-table-column
                        label="操作"
                        fixed="right"
                        width="300"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.id" style="text-align: left;">

                                <el-button
                                    v-if=" _user.usercode ==  scope.row.salesManCode && scope.row.state == 0 && (scope.row.taskType == 4 || scope.row.taskType == 5 ) "
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="designate(scope.row)"
                                >确认指派
                                </el-button>

                                <el-button
                                    v-if="(scope.row.trackStatus == '' || scope.row.trackStatus == null) && _user.usercode ==  scope.row.salesManCode && (scope.row.taskType != 4 && scope.row.taskType != 5  && scope.row.taskType!=9)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="undertakeOpen(scope.row)"
                                >承接
                                </el-button>

                                <!-- 销售人员为当前登录人，并且没有承接的 且不等于员工待指派  -->
                                <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="selectcluedetails(scope.row)">
                                    跟踪日志
                                </el-button>

                                <el-button
                                    v-if="scope.row.trackStatus == '1' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="toProject(scope.row)">
                                    转项目
                                </el-button>

                                <el-button
                                    v-if="scope.row.trackStatus == '4' && (_user.usercode ==  scope.row.salesManCode || scope.row.doProjectFlag)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="updateDetailxs(scope.row.loudId)">
                                    漏斗
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>




        <!--指派-->
        <el-dialog :close-on-click-modal="false" @close='designateDia' :visible.sync="designateDialog"
                   class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>线索指派</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;">
                    <el-form :model="add" label-position="right" :inline="true" label-width="80" :rules="editFormRules"
                             class="demo-ruleForm h-formbLine h-formbLine1">

                        <el-form-item label="区域人员或经销商" prop="province">
                            <el-select v-model="add.assignType" @change="cleanAssign" placeholder="需求类型">
                                <el-option label="区域销售人员" value="1"></el-option>
                                <el-option label="经销商" value="2"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="省" prop="province" v-if="add.assignType == 1">
                            <el-select v-model="add.province" @change="handleItemChange1($event)" placeholder="省"
                                       style="width: 68%;">
                                <el-option
                                    v-for="item in shenglist"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="市" prop="city" v-if="add.assignType == 1">
                            <el-select v-model="this.add.city" @change="handleItemChange2($event)"
                                       :rules="[{ required: true, message: '请输入市', trigger: 'change'},]"
                                       placeholder="市" style="width: 100%;">
                                <el-option
                                    v-for="item in cityList"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="渠道" prop="channelCode" v-if="add.assignType == 1">
                            <brselect category="clue_channel_zb" v-model="add.channelCode" :v="add.channelCode"
                                      :clearable="true"
                                      @change="getdaqujingli('addclue')" :disabled="this.disabled"></brselect>
                        </el-form-item>

                        <el-form-item label="销售人员" prop="salesman" v-if="add.assignType == 1">
                            <el-select v-model="this.add.salesManName" @change="salesmanChange($event)"
                                       placeholder="销售人员" style="width: 100%;">
                                <el-option
                                    v-for="item in salesmanList"
                                    :key="item.id"
                                    :label="`${item.userName}(${item.userCode})`"
                                    :value="item.userName">
                                </el-option>

                            </el-select>
                        </el-form-item>

                        <!--     ----  ----  ----  ----  ---- 经销商分割线       ----  ----  ---- ----      -->
                        <el-form-item label="省" prop="province" v-if="add.assignType == 2">
                            <el-select v-model="add.province" @change="selectClueAgentOwner($event)" placeholder="省"
                                       style="width: 68%;">
                                <el-option
                                    v-for="item in shenglist"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="市" prop="city" v-if="add.assignType == 2">
                            <el-select v-model="this.add.city" @change="handleItemChange2($event)"
                                       :rules="[{ required: true, message: '请输入市', trigger: 'change'},]"
                                       placeholder="市" style="width: 100%;">
                                <el-option
                                    v-for="item in cityList"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="渠道" prop="channelCode" v-if="add.assignType == 2">
                            <brselect category="clue_channel_zb" v-model="add.channelCode" :v="add.channelCode"
                                      :clearable="true"
                            ></brselect>
                        </el-form-item>

                        <el-form-item label="经销商" prop="salesman" v-if="add.assignType == 2">
                            <el-select v-model="this.add.salesManName" @change="salesmanChange($event)"
                                       placeholder="经销商" style="width: 100%;">
                                <el-option
                                    v-for="item in salesmanList"
                                    :key="item.id"
                                    :label="`${item.userName}(${item.userCode})`"
                                    :value="item.userName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-form>

                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="designateDia">取消</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="designatecommit()">提交</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" @close='undertakeClose' :visible.sync="undertakeDialog" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>线索承接</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;">
                    <el-form ref="form" :model="f"
                             :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
                        <el-form-item label="省" prop="province"  class="h-elformWrap-2">
                            <el-input v-model="f.province" placeholder="省" readonly ></el-input>
                        </el-form-item>

                        <el-form-item label="市" prop="city"   class="h-elformWrap-2">
                            <el-input v-model="f.city" placeholder="市" readonly ></el-input>
                        </el-form-item>

                        <el-form-item label="渠道" prop="channelName"  class="h-elformWrap-2">
                            <el-input v-model="f.channelName" placeholder="渠道" readonly ></el-input>
                        </el-form-item>

                        <el-form-item label="项目名称" prop="channelName"  class="h-elformWrap-2">
                            <el-input v-model="f.projectName" placeholder="渠道" readonly ></el-input>
                        </el-form-item>


                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="undertakeClose">取消</el-button>

                    <el-button class="h-btn h-bBtn h-bgblue2"  @click="undertake(f.id,1)" >承接-转商机
                    </el-button>
                    <el-button  class="h-btn h-bBtn h-bgblue2" @click="undertake(f.id,2)" >承接-无效信息
                    </el-button>
                    <el-button  class="h-btn h-bBtn h-bgred"  v-if="f.taskType==0"  @click="undertake(f.id,3)" >拒绝承接
                    </el-button>

                </div>
            </div>

        </el-dialog>


        <!--追踪详情弹出框-->
        <el-dialog :close-on-click-modal="false"  @close='closeCluedetails' :visible.sync="cluedetailsDialog" class="h-dialog6">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>线索日志</h1>
                    </div>
                </div>
            </div>
            <div style="padding-top: 12px;">
                <template>
                    <el-table :data="cluetracktable" border style="width: 100%">
                        <el-table-column label="序号" type="index" width="50"></el-table-column>
                        <el-table-column prop="pushDate" :show-overflow-tooltip="true" label="分发时间" width="150"></el-table-column>
                        <el-table-column prop="pushUserCode" :show-overflow-tooltip="true" label="接收人编码" width="120" >  </el-table-column>
                        <el-table-column prop="pushUserName" :show-overflow-tooltip="true" label="接收人姓名" width="120" >  </el-table-column>
                        <el-table-column prop="pushNodeName" :show-overflow-tooltip="true" label="线索节点" width="100"></el-table-column>

                        <el-table-column prop="isTimeOut" :show-overflow-tooltip="true" label="处理状态" width="100">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isTimeout == 1">已超时</span>
                                <span v-if="scope.row.isTimeout == 0">已处理未超时</span>
                                <span v-if="scope.row.isTimeout == 2">待处理</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pushRole" :show-overflow-tooltip="true" label="接收人角色" width="100"></el-table-column>
                        <el-table-column prop="createRole" :show-overflow-tooltip="true" label="操作人角色" width="100"></el-table-column>
                        <el-table-column prop="operaterType" :show-overflow-tooltip="true" label="操作方式" width="100"></el-table-column>
                        <el-table-column prop="carryDate" label="处理时间" width="150"></el-table-column>
                        <el-table-column prop="cuname" label="操作人" width="100"></el-table-column>
                    </el-table>
                </template>
            </div>
        </el-dialog>


        <div class="h-tableB h-mrt30">
            <div class="h-tableBL" style="margin-left: 23px">

                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                           @click="exportExcel">导出
                </el-button>


            </div>
            <div class="h-pagination2">
                <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
            </div>
        </div>

    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from "moment";

export default {
    components: {
        Treeselect, uploaddownexcel
    },

    props: {
        fromSourceList: {
            type: Array,
        },
        fromSourceType: {
            type: String,
        }
    },

    data() {
        return {
            institutionalX: false,
            // 展开折叠筛选
            isScreen: false,
            closeScreen: require("@/assets/images/pimg/closeallic.png"),
            drawScreen: require("@/assets/images/pimg/dobleArr.png"),
            q: {
                fromSourceList:[],
                province: '',
                bigArea:'',
                salesManName: '',
                salesManNameAndCode:'',
                projectName:'',
                userUnitName: '',
                chainGroup: '',
                proCategory: '',
                channelCode: '',
                clueFrom: '',
                trackStatus: '',
                funnelCode: '',
                startDate: '',
                endDate: '',
                cusername: '',
                state: '',
                incomingCall: '',
                telephone: '',
                pageSize: 10,
                pageNo: 1,
                total: 0,
            },
            size: '',
            tableData: [
                {
                    daqu: '',
                    areaCode: '',
                    areaName: '',
                    province: '',
                    city: '',
                    salesManCode: '',
                    salesManName: '',
                    channelCode: '',
                    channelName: '',
                    clueFrom: '',
                    userUnitCode: '',
                    userUnitName: '',
                    dept: '',
                    leader: '',
                    telephone: '',
                    chainGroup: '',
                    proCategory: '',
                    funnelCode: '',
                    trackStatus: '',
                    userRequire: '',
                    memo: '',
                    cdate: '',
                    doProjectFlag:false,
                }
            ],
            //表单
            f:{

                id: '',
                province: '',
                city: '',
                salesManName: '',
                salesManCode: '',
                channelCode: '',
                channelName:'',
                clueFrom: '',
                userUnitName: '',
                userUnitCode: '',
                telephone: '',
                proCategory: '',
                funnelCode: '',
                userRequire: '',
                memo: '',
                chainGroup: '',
                chainCode: '',
                ids: [],  //checkbook 的 id
                trackStatus: '',
                assignType: ''//指派类型 1区域销售人员 2经销商

            },
            add: {
                id: '',
                province: '',
                city: '',
                salesManName: '',
                salesManCode: '',
                channelCode: '',
                clueFrom: '',
                userUnitName: '',
                userUnitCode: '',
                dept: '',
                leader: '',
                incomingCall: '',
                telephone: '',
                proCategory: '',
                funnelCode: '',
                userRequire: '',
                memo: '',
                chainGroup: '',
                chainCode: '',
                ids: [],  //checkbook 的 id
                trackStatus: '',
                assignType: ''//指派类型 1区域销售人员 2经销商
            },

            oneData:{},

            //线索跟踪详情
            cluetracktable: [
                {
                    id: '',
                    mainId: '',
                    pushDate: '',
                    pushUserCode: '',
                    pushUserName: '',
                    pushNode:'',
                    pushNodeName:'',
                    cucode:'',
                    cuname:'',
                    wlBid:'',
                    memo: '',
                    carryDate:'',
                    isTimeout:'',
                }
            ],

            rowid: '',   //行 id
            loudid: '', // 漏斗id
            row: '',   //行

            areaCode: null,  // 目前没有用
            isloud: false,


            shenglist: [],      //省份list
            salesmanList: [],  // 销售人员list
            cityList: [],      //城市list
            customerNameList: [], //用户单位list
            agentList: [],      //签约经销商
            deptNameList: [],  //单位名称
            addressTypeList: [],
            stVal: null,
            lianqun: '',
            productByNameList: [],
            multipleSelection: [],  //获取选中 表格的集合

            proSelect: {
                pcode: 0,
                level: 1,
            },

            qweekList: [],
            sexList: [0, 1],

            //表单弹出窗 属性设置
            newDialog: false,
            writeNissin: false,
            editDialog: false,

            cluedetailsDialog: false,//线索日志
            loudmainDialog: false,
            newDialogUser: false,
            designateDialog: false,  //用于指派的对话框
            undertakeDialog: false,  //承接对话框
            batchpressDialog: false,  //用于批量催办的弹出框

            //是否禁用
            disabled: false,
            euTypeFlag: false,
            //批量导入
            uploaddownexcelflag: false,
            daqujlFlag: false,
            xiansuouser: false,
            adminFlag: false,
            dailishangFlag: false,
            usercode: '',


            yearList: [new Date().getFullYear(), new Date().getFullYear() + 1],
            weekList: [],
            nissin: {
                answerTime: '',
                defultFlag: '',
                dailyQuestion: '',
                customerName: '',
                visitDate: '',
                endDate: '',
                visitContent: "",
                dailyContent: '',
                isProject: 0,
                id: '',
                isConShow: false,
                isProjectBtn: false,
                chainGroupName: '',
                chainGroupCode: '',
                visitEffect: '',
                title: '',
                statusR: '',
                selectVisitEffect: ['a', 'b'],
                gameTitles: [],
                subJieProgess: [], // 需求子节点数据
                childMsgId: '',
                //yucePrice: '', // 月预算在下单
                expConvDate: '',
                department: '',
                telephone: '',
                contactUserName: "",
                lianqunCode: '',
            },

            authTypeListEdit: [],
            wirteNissinList: [],
            disEdit: false,
            workList: [],
            deptList: [],
            userLists: [],
            custNameList: [],

            AuthoCheck: '',
            authTypeList: [],
            userList: [0],
            weekPlanList: [],
            groupList: [],
            groupArr: [],
            titleDig: "",
            optionList: [],
            qyearList: [],
            editFormRules: {
                areaCode: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                channelCode: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                salesManName: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                clueFrom: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                telephone: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                trackDate: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                trackContent: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                userRequire: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            },


            cluesList: [],
        }
    },
    methods: {


        //明细导出
        exportExcel() {
            updownfile.down("/api/swyl/v1/guanhuai/bscClueZhaobiao/downloadExcel", this.q, "post", 'data');
        },
        // 批量 导出
        uploaddownexcelflagbtn() {
            this.uploaddownexcelflag = true;
        },


        employeesdetails(o) {
            this.$router.push(
                {
                    //添加需要传值到那个页面的路径
                    path: 'loudnew/LoudMain',
                    //携带需要传递的参数
                    query: {funcode: o}
                })
        },

        getKnowWeek() {
            var week1 = this.getWeekNum();
            this.qweekList.forEach(element => {
                if (week1 == element.week) {
                    this.q.week = element.week
                }
            });
        },
        getqWeeks(y, z) {
            ss.MuBiao.getWeekList({year: y, stype: z}).then(rd => {
                this.qweekList = rd;
                this.getKnowWeek();
            })
        },


        //获取今年是第几周
        getWeekNum() {
            //获得当前日期是第几周的方法
            var year = new Date().getFullYear();
            var week = moment(new Date()).format("E");//获得今天是星期几
            var startweek = moment(new Date(year + "-01-01")).format("E");//获得今年的1月1号是星期几
            //今天到1月1号的时间戳之差
            var millisDiff =
                new Date(moment().format("yyyy-MM-DD")).getTime() -
                new Date(year + "-01-01").getTime();
            var days =
                (millisDiff -
                    week * (24 * 60 * 60 * 1000) -
                    (7 - startweek) * (24 * 60 * 60 * 1000)) /
                86400000;
            return days / 7;
            //这里加的2代表的是本周和今年1月1号所在的那一周
        },

        //改动和并列的
        arraySpanMethod() {
            this.$nextTick(() => {
                if (this.$refs.multipleTable.$el) {
                    var current = this.$refs.multipleTable.$el
                        .querySelector(".el-table__footer-wrapper")
                        .querySelector(".el-table__footer");
                    var cell = current.rows[0].cells;
                    cell[0].style.display = "none";
                    cell[1].style.display = "none";
                    cell[2].style.display = "none";
                    cell[3].style.display = "none";
                    cell[4].style.display = "none";
                    cell[5].style.display = "none";
                    cell[10].style.display = "none";
                    cell[6].classList.remove('is-left');
                    cell[6].colSpan = "7";
                }
            })
        },

        query() {
            this.selectPageAll()
        },


        undertakeOpen(obj){
            this.f =obj;
            this.undertakeDialog = true;

        },



        /*承接操作*/
        undertake(id,trackStatus){

            this.$confirm(
                trackStatus === 1 ? '是否确认确认转为商机？' :  trackStatus === 2 ? '是否确认确认转为无效信息？' : '是否确认确认拒绝承接？' ,
                        '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
               type: 'warning'

            })
            .then(_ => {
                let query = {
                    id: id,
                    trackStatus: trackStatus,
                }
                ss.BscClueZhaoBiao.undertake(query).then(rd => {
                    this.$msg.msgs("提交成功！");
                    this.undertakeClose();
                    this.selectPageAll()
               })

            })
            .catch(_ => {

            });
        },

        updateDetail(row) {

            this.authTypeListEdit = []
            this.titleDig = "修改内容"
            var data = row.id
            ss.MuBiao.getbscConcactpersonSingle(data).then(res => {
                console.log("--------------");
                console.log(res.msg);
                this.authTypeListEdit = res.msg;
                this.add = res.obj;

                //查询区域和渠道下的销售人员
                if (this.add.province != null && this.add.province != '' && this.add.channelCode != null && this.add.channelCode != '') {
                    var distribution = this.$getDictName("clue_channel_zb", this.add.channelCode);

                    var data = {
                        "province": this.add.province,
                        "city": this.add.city,
                        "distribution": distribution
                    }
                    ss.clueOwner.selectClueOwner(data).then(res => {
                        //通过渠道给销售人员赋值
                        console.log(res.obj, "res.obj111");
                        this.salesmanList = res.obj;
                        console.log(this.salesmanList, "this.salesmanList");
                        //需要的数据进行封装放入下拉集合中
                        var newdata = {
                            "id": this.add.salesManCode,
                            "userName": this.add.salesManName,
                            "userCode": this.add.salesManCode
                        }
                        //防止区域编码和渠道编码查询出来的数据和修改带出来的默认值重复
                        for (var i = 0; i < this.salesmanList.length; i++) {
                            if (this.add.salesManCode != this.salesmanList[i].userCode) {
                                this.salesmanList.push(newdata);
                            }
                        }
                        //给默认值销售人员工号和name拼接
                        this.add.salesManName = this.add.salesManName;
                        //给默认值销售人员工赋值
                        this.add.salesManCode = this.add.salesManCode;
                    })
                }

            })
            this.editDialog = true
        },


        addZero(i) {
            if (i < 10) {
                i = "0" + i;
            }
            return i;
        },
        myFunction() {
            var d = new Date();
            var month = this.addZero(d.getMonth() + 1)
            var day = this.addZero(d.getDate())
            var h = this.addZero(d.getHours());
            var m = this.addZero(d.getMinutes());
            var s = this.addZero(d.getSeconds());
            return d.getFullYear() + "-" + month + "-" + day + " " + h + ":" + m + ":" + s;
        },






        selectPageAll() {
            ss.BscClueZhaoBiao.selectPage(this.q).then(rd => {
                this.tableData = rd.records;
                // console.log(this.tableData);
                // console.log(res);d
                this.q.total = rd.total;
            })
        },


        //checkbook  获取多选框元素
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        //指派
        designate(data) {

            this.$router.push({
                path: '/designateClueZhaoBiao',
                query: {id: data.id}
            })
        },

     /*   //指派
        designate(data) {

            if (this.multipleSelection.length == 0 || this.multipleSelection == null) {
                this.$message.error("没有选中可以指派的!");
                return false;
            }
            // var idlist = [];
            console.log(this.multipleSelection)
            this.multipleSelection.forEach(element => {
                this.add.ids.push(element.id);
            });
            console.log("888888888888888888")
            console.log(this.add.ids)
            this.designateDialog = true;
            this.titleDig = "指派";
        },*/






        designatecommit() {

            if (!this.add.province) {
                this.$message.error("省没有指派!");
                return false;
            }
            if (!this.add.city) {
                this.$message.error("城市没有指派!");
                return false;
            }
            if (!this.add.salesManName) {
                this.$message.error("销售人员没有指派!");
                return false;
            }
            this.add.channelName = this.$getDictName("clue_channel_zb", this.add.channelCode);

            //过滤销售人员的编码
            var product = _.find(this.salesmanList, {userName: this.add.salesManName});

            this.add.salesManCode = product.userCode;

            console.log("this.add",this.add)
            ss.BscClueZhaoBiao.designate(this.add).then(res => {
                if (res.f == true) {
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.selectPageAll()
                    this.designateDia()
                } else {
                    this.$message.error(res.msg);
                    this.designateDia()
                }
            })

        },


        getqWeeksBySelectYear() {
            this.getqWeeks(this.q.year, 1);
        },
        // 展开折叠
        collapseChange() {
            this.isScreen = !this.isScreen;
        },
        create() {
            this.newDialog = true;
            this.titleDig = "新建线索"
        },
        rest() {
            this.q.areaName = '',
                this.q.salesManName = '',
                this.q.userUnitName = '',
                this.q.chainGroup = '',
                this.q.proCategory = '',
                this.q.channelName = '',
                this.q.clueFrom = '',
                this.q.trackStatus = '',
                this.q.state = '',
                this.q.funnelCode = '',
                this.q.startDate = '',
                this.q.endDate = '',
                this.q.incomingCall = '',
                this.q.telephone = ''
            // pageSize: 10,
            // pageNo: 1,
            // total: 0,
        },


        loadArea(i) {
            let proSelect = {
                pcode: 0,
                level: 1,
            }
            console.log(proSelect)
            ss.Dictservice.arealist(proSelect).then(rd => {
                this.shenglist = rd;
            })
        },


        getdaqujingli(type) {

            this.add.channelName = this.$getDictName("clue_channel_zb", this.add.channelCode);

            if (this.add.province == null || this.add.province == '' || this.add.city == null || this.add.city == '') {
                this.$message.error("请先选择省市");
                this.add.channelCode = '';
                return;
            }

            //由区域和渠道选着大区经理
            if (this.add.province != null && this.add.province != '' && this.add.channelCode != null && this.add.channelCode != '') {
                this.add.salesManName = '';
                var data = {
                    "province": this.add.province,
                    "city": this.add.city,
                    "distribution": this.add.channelName
                }
                //线索新增走新逻辑 在区域查询销售人员逻辑基础上增加通过区域和渠道锁定销售人员
                console.log(data, "585556668552");
                ss.clueOwner.selectClueOwner(data).then(res => {
                    //如果是新增需要给默认值
                    if (type == 'addclue') {
                        if (res.obj.length == 1) {
                            //拼接姓名和工号
                            this.add.salesManName = res.obj[0].userName + "(" + res.obj[0].userCode + ")";
                            //默认销售用户工号
                            this.add.salesManCode = res.obj[0].userCode;
                        } else {
                            for (var i = 0; i < res.obj.length; i++) {
                                //判断如果有多个销售人需要判断是否是接口人进行默认
                                if (1 == res.obj[i].isDefault) {
                                    //拼接姓名和工号
                                    this.add.salesManName = res.obj[i].userName + "(" + res.obj[i].userCode + ")";
                                    //默认销售用户工号
                                    this.add.salesManCode = res.obj[i].userCode;
                                }
                            }
                        }
                    }
                    //通过渠道给销售人员赋值
                    this.salesmanList = res.obj;
                })
            }
        },

        // 省份选择器
        handleItemChange1(o) {

            //清空市，销售人员
            this.add.city ='';
            this.add.salesManName=''

            this.add.provinceList = _.find(this.shenglist, {code: o});
            console.log("provinceList",this.add.provinceList)

            this.add.province = this.add.provinceList.name;



            ss.Dictservice.getCity({code: o}).then(rd => {
                this.cityList = rd.zlist;
            })
        },
        handleItemChange2(o) {
            this.add.city = o;
        },

        salesmanChange(o) {
            this.add.salesManName = o;
        },

        //根据省查询对应的经销商
        selectClueAgentOwner(o) {
            this.add.city ='';
            this.add.salesManName=''

            this.add.provinceList = _.find(this.shenglist, {code: o});
            this.add.province = this.add.provinceList.name;
            var data  = {
                "province":this.add.province,
            }
            ss.clueAgentOwner.selectClueAgentOwner(data).then(res => {

                this.salesmanList=[];
                for (var i = 0; i < res.obj.length; i++) {
                    //拼接姓名和工号
                    this.add.salesManName = res.obj[i].agentName ;
                    //默认销售用户工号
                    this.add.salesManCode = res.obj[i].agentCode;
                    var newdata = {
                        "id": this.add.salesManCode,
                        "userName": this.add.salesManName,
                        "userCode": this.add.salesManCode
                    }
                    this.salesmanList.push(newdata);
                }
            })

            ss.Dictservice.getCity({code: o}).then(rd => {
                this.cityList = rd.zlist;
            })
        },





        //查看流转日志
        selectcluedetails(row){
            var data ={
                "mainId":row.id
            }
           //根据id查询线索跟踪
            ss.BscClueZhaoBiao.selectCluePushLog(data).then(res =>{
                this.cluetracktable = res.records;

            })
            this.cluedetailsDialog = true
        },

        /**
         * 转项目
         * */
        toProject(row){
            this.$router.push({
                path: "/clueToProject",
                query: {id: row.id}
            })
        },
        updateDetailxs(id){
            if(!id){
                this.$msg.msge("无关联id!");
                return ;
            }
            var path = '/infoIndex';
            let routeData = this.$router.resolve({path: path, query: {'id':id}});
            window.open(routeData.href, '_blank');
        },

        mounted() {
            this.selectPageAll();
        },
        //关闭表单
        designateDia() {
            this.designateDialog = false

            this.add.province = '',
            this.add.city = '',
            this.add.salesManName = '',
            this.add.ids = []
            this.salesmanList = null;
            this.cityList = null;
            this.add.assignType='';
        },
        //关闭承接表单
        undertakeClose(){
            this.undertakeDialog = false
            this.f ={};
        },
        //关闭线索跟踪详情
        closeCluedetails(){
            this.cluedetailsDialog = false;

             this.cluetracktable = [];
        },
        //清空指派信息
        cleanAssign(){
            this.add.city='';
            this.add.salesManName='';
            this.add.salesManCode='';
            this.add.province='';
            this.add.channelCode='';
        },


        closeDialog() {

            this.newDialog = false
            this.editDialog = false
            this.writeNissin = false
            // this.xxx = '';//清空数据
            this.add.id = '',

                this.add.province = '',
                this.add.city = '',
                this.add.salesManName = '',
                this.add.channelCode = '',
                this.add.clueFrom = '',
                this.add.userUnitName = '',
                this.add.dept = '',
                this.add.leader = '',
                this.add.telephone = '',
                this.add.proCategory = '',
                this.add.incomingCall = null,
                this.add.userRequire = null
            this.add.funnelCode = '',
                this.add.memo = '',
                this.add.chainGroup = '',
                this.add.chainCode = '',
                this.add.trackStatus = '',
                this.add.ids = [],
                this.salesmanList = null;
            this.cityList = null;
            this.edit.targetContent = '',
                this.edit.customerName = '',
                this.edit.projectName = ''

        },




        // 通过销售人员名称去查询
        showInfo(event) {
            for (var i = 0; i < this.allsaleman.length; i++) {
                var ishave = false;
                for (var j = 0; j < this.salesmanList.length; j++) {
                    /****
                     * 1、判断this.salesmanList[j] 是否为空
                     * 2、判断下拉集合数据的销售人员名称和总集合销售人员名称是否一致
                     * 3、判断下拉集合数据的销售人员名称和页面输入名称是否一致
                     *
                     **/
                    if (this.salesmanList[j]
                        && this.salesmanList[j].userName == this.allsaleman[i].userName
                        && this.salesmanList[j].userName == event.target.value) {
                        //去判断下拉集合数据的销售人员工号是否已经存在
                        if (this.salesmanList[j].userCode == this.allsaleman[i].userCode) {
                            ishave = true;
                            break;
                        }
                    }
                }
                if (!ishave && event.target.value == this.allsaleman[i].userName) {
                    this.salesmanList.push(this.allsaleman[i]);
                }
            }
        },
        loadClueResource() {
            ss.BscClueManage.getClueResource().then(rd => {
                if (rd.f) {
                    this.cluesList = rd.msg;
                }
            })
        },
        changeEuType(val) {
            console.log(val);
            //如果是经销商就展示
            if (val == 2) {
                this.euTypeFlag = true;
            } else {
                this.euTypeFlag = false;
            }
        },

        matchChannel(value) {
            console.log("value", value)
            ss.nxAddress.getAddressTypeByChannel(value).then(rd => {
                this.addressTypeList = rd.msg;
                // this.add.schoolTypeName = '';
            })
        },
        //地址选择器-新
        handleItemChangeN(o) {
            this.address = _.find(this.shenglist, {code: this.add.provinceId});
            // this.add.province = this.address.name;
            ss.Dictservice.areaTreelist({code: o}).then(rd => {
                this.arealist2 = rd.zlist;
                this.arealist3 = [];
                this.address = _.find(this.arealist2, {code: this.add.cityId});
                // this.add.city = this.address.name;
                this.arealist3 = _.find(this.arealist2, {code: o}).zlist
            })
        },

        isUrl(str) {
            return typeof str === 'string' && (str.startsWith('http://') || str.startsWith('https://'));

        },
        openUrl(url){
            window.open(url, '_blank');
        }

    },
    watch: {
        'add.customerName': {
            deep: true,
            handler: function (newVal, oldVal) {
                this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
                var len = this.groupList.length;//groupList
                var arr = [];
                for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
                    if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
                        arr.push({
                            value: this.groupList[i].name,
                            id: this.groupList[i].id
                        })
                    }
                }
                this.groupArr = arr
            }
        },
    },
    created() {
        this.q.fromSourceList = this.fromSourceList;
        console.log('fromSourceType:', this.fromSourceType);

        //是否管理员权限
        this.adminFlag = this.$store.getters.hasRole('swyl_admin');
        //是否省区经理权限
        this.daqujlFlag = this.$store.getters.hasRole('swyl_daqujl');
        //是否线索渠道负责人
        this.xiansuouser = this.$store.getters.hasRole('swyl_xiansuo_user');

        this.usercode = this._user.usercode;
        this.query();
        this.loadClueResource();
        this.loadArea();
    },

}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
    width: 110px;
}

/deep/ .h-formbLine .el-form-item__content {
    width: 150px;
}

/*/deep/ .h-elformWrap-1 .el-form-item__content{*/
/*    width: 78%;*/
/*}*/
/deep/ .h-elformWrap-1 .el-form-item__content {
    width: 78%;
}

.addPro {
    width: 100%;
    /* display:flex; */
}

.addPro .el-form-item {
    width: 45% !important;
}

.addPro .el-form-item /deep/ .el-form-item__content {
    width: 115px;
}

/*设置父级样式*/
.vue-treeselect >>> .vue-treeselect__control {
    width: 150px;
}

.el-switch {
    margin: auto auto auto 20px;
}

/*.projectCon p{*/
/*  justify-content: space-between;*/
/*  align-items:center;*/
/*  font-size: 14px;*/
/*  border-bottom:#1b78e6 1px dashed;*/
/*  padding: 5px 0;*/
/*  margin: 0 auto 10px auto;*/
/*  color: #1b78e6;*/
/*}*/
</style>
